import { FC } from 'react';

import * as RadioGroup from '@radix-ui/react-radio-group';
import { Text } from '@versumstudios/ui';

import * as Styles from './styles';

interface IRadioItem {
  value: string;
  label: string;
}

export const RadioItem: FC<IRadioItem> = (props) => {
  const { value, label } = props;
  return (
    <RadioGroup.Item value={value} asChild>
      <Styles.Container>
        <Styles.Radio>
          <RadioGroup.Indicator asChild>
            <Styles.Indicator />
          </RadioGroup.Indicator>
        </Styles.Radio>

        <Text unset css={{ color: '$secondaryFill', marginLeft: '$space$4' }}>
          {label}
        </Text>
      </Styles.Container>
    </RadioGroup.Item>
  );
};
